import { Link } from "react-router-dom";
import { partnerBrands } from "@/mocks/brands";

const largeBrandNames = new Set([
  "ANUA", "Arencia", "AXIS-Y", "BANILA CO", "dasique", "ELROEL",
  "EQQUALBERRY", "ETUDE", "HYGGEE", "JMsolution", "ma:nyo",
  "MENOKIN", "SKIN1004", "SOME BY MI",
]);

export default function FeaturedBrands() {
  const featured = partnerBrands.filter((b) => b.logo).slice(0, 10);

  return (
    <section className="w-full px-6 md:px-12 lg:px-20 py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-accent-500" />
            <span className="font-label text-[11px] tracking-[0.22em] uppercase text-accent-700">
              Brand Access
            </span>
            <span className="w-8 h-px bg-accent-500" />
          </div>
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
            125+ Korean Beauty Brands,
            <br />
            <span className="italic">One Export Partner</span>
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-foreground-700 text-base md:text-lg leading-relaxed font-light">
            Consolidate products from multiple Korean brands into one order, one shipment and one point of contact.
          </p>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-5 md:gap-7 items-center justify-items-center">
          {featured.map((brand) => (
            <div
              key={brand.name}
              className="group flex items-center justify-center p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-300 hover:bg-background-50 transition-all cursor-pointer w-full h-[160px] md:h-[180px]"
            >
              {brand.logo ? (
                <img
                  src={brand.logo}
                  alt={`${brand.name} brand logo`}
                  className={`object-contain ${
                    largeBrandNames.has(brand.name)
                      ? "max-w-[98%] max-h-[140px] md:max-h-[160px]"
                      : "max-w-[92%] max-h-[110px] md:max-h-[130px]"
                  }`}
                />
              ) : (
                <span className="font-heading text-foreground-950 text-lg md:text-xl leading-tight text-center group-hover:text-accent-700 transition-colors">
                  {brand.name}
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/brands"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-100 text-secondary-900 hover:bg-accent-100 hover:text-accent-700 border border-secondary-200 hover:border-accent-300 transition-colors font-label text-[12px] tracking-[0.14em] uppercase"
          >
            View All Brands
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}